import React, { useContext, useEffect, useState } from "react";
import {
  AdsData,
  CategoryList,
  MarketPlaceCategoryList,
  ServiceListData,
} from "./Views/Marketplace/Service/SubCategory";
import { useNavigate } from "react-router-dom";
import GigsCart from "../../components/Dashboard/GigsCart";
import MarketplaceCart from "../../components/Dashboard/MarketplaceCart";
import AlertContext from "../../Context/Alert/AlertContext";
import { BaseURL } from "../../Files/BaseURL";
import axios from "axios";
import ThemeContext from "../../Context/theme/ThemeContext";

const Dashboard = () => {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  // const [SeletedMarketCategory, setSeletedMarketCategory] = useState("Vehicles")

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [services, setServices] = useState([]);
  const [Gigs, setGigs] = useState([]);
  const [SeletedMarketCategory, setSeletedMarketCategory] = useState();
  const [Categories, setCategories] = useState([]);
  const [Products, setProducts] = useState([]);
  const [User, setUser] = useState({});

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;

  const fetchServices = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(
        `${BaseURL}/api/marektplace/Service/servicecategoryname`,
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      const data = await response.json();
      setServices(data);
      setSelectedCategory(data[0]?._id);
    } catch (error) {
      showAlert("Error fetching Services", "danger");
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServiceSkills = async (category) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(
        `${BaseURL}/api/marektplace/Service/industryskill/${category}`,
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      const data = await response.json();
      setGigs(data);
    } catch (error) {
      showAlert("Error fetching Service Skills", "danger");
    }
  };

  useEffect(() => {
    if (selectedCategory) {
      fetchServiceSkills(selectedCategory);
    }
  }, [selectedCategory]);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${BaseURL}/api/product/productcategory`
      );
      setCategories(response.data);
      setSeletedMarketCategory(response?.data[0]?._id);
    } catch (error) {
      showAlert("Error fetching categories", "danger");
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchUser();
  }, []);

  const fetchProducts = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/marektplace/products/fetchproducts/${SeletedMarketCategory}`,
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      setProducts(response.data?.data || []);
    } catch (error) {
      showAlert("Error fetching products", "danger");
      setProducts([]);
    }
  };

  useEffect(() => {
    if (SeletedMarketCategory) {
      fetchProducts();
    }
  }, [SeletedMarketCategory]);

  const fetchUser = async () => {
    const response = await axios.get(`${BaseURL}/api/user/userstatus`, {
      headers: {
        "auth-token": localStorage.getItem("p@token"),
        "Content-Type": "application/json",
      },
    });
    if (response) {
      setUser(response.data);
    }
  };

  return (
    <div className="w-[95%] m-auto py-6 flex flex-col gap-6">
      <div className="bg-gradientdata flex flex-col gap-6 rounded-xl pt-4 md:pt-6 pb-10 md:pb-16 px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row justify-between md:items-center font-pop">
          <h2 className="text-white font-semibold text-xl md:text-2xl">
            Welcome {User?.FirstName} {User?.LastName}
          </h2>
          <button
            className="text-base md:text-lg self-end md:self-auto border-2 bg-transparent font-medium text-white border-white py-2 px-4 rounded-xl hover:bg-white hover:text-black ease-in-out duration-300"
            onClick={() => {
              navigate("/user-dashboard/withdraw-history");
            }}
          >
            Recent History
          </button>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-6">
          <div className="bg-white font-pop rounded-2xl overflow-hidden">
            <div
              className={`border-l-8  border-[#00B3FF] py-4 px-4 ml- flex flex-col gap-2 justify-center
                   ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}
            >
              <h4
                className={`text-sm md:text-base text-lightGrey font-normal 
               ${theme == "dark" && "text-white"} `}
              >
                My Balance
              </h4>
              <h2 className="text-lg md:text-2xl font-semibold">
                ${User.PaymentBalance?.toFixed(2)}
              </h2>
            </div>
          </div>
          <div
            className={` font-pop rounded-2xl overflow-hidden ${
              theme == "dark" ? "bg-black text-white" : "bg-white "
            }`}
          >
            <div className="border-l-8  border-[#2DD683] py-4 px-4 ml- flex flex-col gap-2 justify-center">
              <h4
                className={`etxt-sm md:text-base text-lightGrey font-normal  *:  ${
                  theme == "dark" && "text-white"
                }`}
              >
                Withdraw
              </h4>
              <h2 className="text-lg md:text-2xl font-semibold">
                ${User.PaymentWithdraw?.toFixed(2)}
              </h2>
            </div>
          </div>
          <div
            className={` font-pop rounded-2xl overflow-hidden    ${
              theme == "dark" ? "bg-black text-white" : "bg-white "
            }  `}
          >
            <div className="border-l-8  border-[#FED142] py-4 px-4 ml- flex flex-col gap-2 justify-center">
              <h4
                className={`text-sm md:text-base text-lightGrey font-normal *:  ${
                  theme == "dark" && "text-white"
                }`}
              >
                Transactions
              </h4>
              <h2 className="text-lg md:text-2xl font-semibold">
                ${User.PaymentTransaction?.toFixed(2)}
              </h2>
            </div>
          </div>
          <div
            className={`  font-pop rounded-2xl overflow-hidden ${
              theme == "dark" ? "bg-black text-white" : "bg-white "
            }  `}
          >
            <div className="border-l-8  border-[#FA8B3A] py-4 px-4 ml- flex flex-col gap-2 justify-center">
              <h4
                className={`text-sm md:text-base text-lightGrey font-normal
                ${theme == "dark" && "text-white"}`}
              >
                Expense
              </h4>
              <h2 className="text-lg md:text-2xl font-semibold">
                ${User.PaymentExpense?.toFixed(2)}
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col font-pop gap-4">
        <h2 className="font-pop text-xl font-semibold">Gigs you may like</h2>
        <div className="py-4 flex flex-wrap font-pop items-center gap-2">
          {services?.map((item, index) => (
            <div
              className={`cursor-pointer rounded-2xl py-1 px-2 border-2 font-pop 
                ${
                  item._id === selectedCategory
                    ? `border-primarygreen  bg-primarygreen/20`
                    : `border-white ${
                        theme == "dark" ? "bg-black text-white" : "bg-white"
                      }`
                } 
              `}
              key={index}
              onClick={() => setSelectedCategory(item._id)}
            >
              {item.name}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 font-pop gap-x-4 gap-y-6">
          {Gigs?.map((item, index) => (
            <GigsCart item={item} key={index} />
          ))}
        </div>
      </div>

      <div className="flex flex-col font-pop gap-4">
        <h2 className="font-pop text-xl font-semibold">
          Physical Goods you may like
        </h2>

        <div className="py-4 flex flex-wrap font-pop items-center gap-2">
          {Categories.map((item, index) => (
            <div
              className={`cursor-pointer rounded-2xl py-1 px-2 border-2 font-pop ${
                item._id == SeletedMarketCategory
                  ? "border-primarygreen bg-primarygreen/20 "
                  : " border-white"
              }
              ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}
              key={index}
              onClick={() => {
                setSeletedMarketCategory(item._id);
              }}
            >
              {item.name}
            </div>
          ))}
        </div>

        <div
          className={`py-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-6`}
        >
          {Array.isArray(Products) && Products.length > 0 ? (
            Products.slice(0, 6).map((item, index) => (
              <MarketplaceCart item={item} key={index} />
            ))
          ) : (
            <div className="col-span-full text-center py-4 text-gray-500">
              No products available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
